import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { AnalyticsDateRange } from "@/lib/date-utils";
import { analyticsService } from "@/services/AnalyticsService";

export const ANALYTICS_STALE_TIME = 1000 * 60 * 5;

export type AnalyticsLoaderData = AnalyticsDateRange;

export const getAnalyticsDashboardQueryKey = (
  startDate: string,
  endDate: string,
) => ["analytics", "dashboard", startDate, endDate] as const;

interface UseAnalyticsDashboardParams {
  startDate: string;
  endDate: string;
}

export const useAnalyticsDashboard = ({
  startDate,
  endDate,
}: UseAnalyticsDashboardParams) =>
  useQuery({
    queryKey: getAnalyticsDashboardQueryKey(startDate, endDate),
    queryFn: () => analyticsService.getDashboard(startDate, endDate),
    placeholderData: keepPreviousData,
    staleTime: ANALYTICS_STALE_TIME,
  });
